import React, { ReactNode } from 'react';
import { Container } from '@fiverr-private/layout_components';

interface SimpleFormWrapperProps {
  children: ReactNode;
}

export const SimpleFormWrapper = ({ children }: SimpleFormWrapperProps) => (
  <Container paddingX="6" paddingY={{ default: '8', sm: '12' }}>
    <Container maxWidth="465px" margin="auto">
      {children}
    </Container>
  </Container>
);
